	export enum AssignedToPatientThroughEnum {
		Sale = 1,
		AddedByUser = 2,
		Import = 3
	}
